import actions from '../../actions-list';
import {routerActions} from 'react-router-redux';

export const setRouteToDefaultTab = () =>
    dispatch => {

        dispatch(routerActions.push('/rga/recalled/advance-returned?tab=dealerInfo'));

    };

export const updateRgaDealerInfoValues = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_RETURNED_DEALER_INFO_VALUES,
    value
});

export const updateRgaConsignmentValues = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_RETURNED_CONSIGNMENT_VALUES,
    value
});



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/action-creators/advance-returned-part-info-form.js